import { Link } from "react-router-dom";
import { Flex, Typography } from "@payping/web-components";
import useTranslator from "@/shared/translate/translator";
import { Constants as routerConstants } from "@/refund/routes";
import { CuToman } from "@payping/icons";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";

const BalancePopover: React.FC = () => {
  const { t } = useTranslator();
  const balance = 0;
  const isActive = false;

  return (
    <Flex vertical className="!tw-w-full" gap="middle">
      <Typography.Text type={"secondary"}>{t("refund.popover.balance")}</Typography.Text>
      <Flex justify={"space-between"}>
        <Flex align="center">
          <Typography.Text strong>{`${formatLocalizedNumber({ value: balance ?? 0 })}`}</Typography.Text>
          <CuToman width={24} height={24} />
        </Flex>
        {!isActive && <Link to={routerConstants.init.url}>{t("activate")}</Link>}
      </Flex>
    </Flex>
  );
};
export default BalancePopover;
